import { Divider, Typography, Tag } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import ViewActiveKanban from "../../../components/Comman/BinMaststerTable";
import "../../../styles/global-ui.css";

const ViewCardDataPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedLocation, setSelectedLocation] = useState("");

  const getDecodedQueryString = () => {
    const decodedValue = decodeURIComponent(location.search.substring(1) || "");
    setSelectedLocation(decodedValue);
    return decodedValue;
  };

  useEffect(() => {
    getDecodedQueryString();
  }, [location.search]);

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            <ArrowLeftOutlined
            
              style={{ marginRight: 12, cursor: "pointer" }}
            />
            View {selectedLocation || "Bin Data"}
          </Typography.Title>

          <Typography.Text className="page-subtitle">
            Search and view grouped bin records by selected location
          </Typography.Text>
        </div>

        <Tag className="filter-tag" color="blue">
          Location: {selectedLocation || "--"}
        </Tag>
      </div>

      <Divider className="page-divider" />

      <ViewActiveKanban />
    </div>
  );
};

export default ViewCardDataPage;